import { render, staticRenderFns } from "./DoubleSlider.vue?vue&type=template&id=4d4d0897&"
import script from "./DoubleSlider.vue?vue&type=script&lang=js&"
export * from "./DoubleSlider.vue?vue&type=script&lang=js&"
import style0 from "./DoubleSlider.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports